import Container from './container'
import Reducer from './reducer'
import {processResponse as process} from './actions'

export {
  process,
  Reducer
}

export default Container


// WEBPACK FOOTER //
// ./src/auth-personnel/index.js